import React from 'react';
import { useAuth } from '../context/AuthContext';
import './Account.css';

const Account = () => {
  const { user } = useAuth();
  return (
    <div className="account-screen">
      <h1 className="account-title">Account</h1>
      <div className="account-detail-box">
        <div className="account-row">
          <span className="account-label">Name</span>
          <span className="account-value">{user?.name || 'User'}</span>
        </div>
        <div className="account-row">
          <span className="account-label">Email</span>
          <span className="account-value">{user?.email || '-'}</span>
        </div>
        <div className="account-row">
          <span className="account-label">User ID</span>
          <span className="account-value">{user?.userId || user?.id || '-'}</span>
        </div>
      </div>
    </div>
  );
};

export default Account;
